export var SystemStatusSubject;
(function (SystemStatusSubject) {
    SystemStatusSubject["SystemStatusIframe"] = "system-status-iframe";
})(SystemStatusSubject || (SystemStatusSubject = {}));
//# sourceMappingURL=system-status.enum.js.map